<template><div><h3>XImg_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fx-img"/>
<p><a href="https://vux.li/demos/v2/#/component/x-img" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/x-img</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/x-img" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">v-for</span>=<span class="hljs-string">"src in list"</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"background-color:yellow;text-align:center;"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">span</span> <span class="hljs-attr">style</span>=<span class="hljs-string">"font-size:20px;"</span>&gt;</span>Loading<span class="hljs-tag">&lt;/<span class="hljs-name">span</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">x-img</span> <span class="hljs-attr">:src</span>=<span class="hljs-string">"src"</span> <span class="hljs-attr">:webp-src</span>=<span class="hljs-string">"`${src}?type=webp`"</span> <span class="hljs-attr">@on-success</span>=<span class="hljs-string">"success"</span> <span class="hljs-attr">@on-error</span>=<span class="hljs-string">"error"</span> <span class="hljs-attr">class</span>=<span class="hljs-string">"ximg-demo"</span> <span class="hljs-attr">error-class</span>=<span class="hljs-string">"ximg-error"</span> <span class="hljs-attr">:offset</span>=<span class="hljs-string">"-100"</span> <span class="hljs-attr">container</span>=<span class="hljs-string">"#vux_view_box_body"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">x-img</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { XImg } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    XImg
  },
  <span class="hljs-attr">methods</span>: {
    success (src, ele) {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'success load'</span>, src)
      <span class="hljs-keyword">const</span> span = ele.parentNode.querySelector(<span class="hljs-string">'span'</span>)
      ele.parentNode.removeChild(span)
    },
    error (src, ele, msg) {
      <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'error load'</span>, msg, src)
      <span class="hljs-keyword">const</span> span = ele.parentNode.querySelector(<span class="hljs-string">'span'</span>)
      span.innerText = <span class="hljs-string">'load error'</span>
    }
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">list</span>: [
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test1.jpg'</span>,
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test2.jpg'</span>,
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test0.jpg'</span>,
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test4.jpg'</span>,
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test5.jpg'</span>,
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test6.jpg'</span>,
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test7.jpg'</span>,
        <span class="hljs-string">'https://o5omsejde.qnssl.com/demo/test8.jpg'</span>
      ]
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">style</span>&gt;</span><span class="css">
<span class="hljs-selector-class">.ximg-demo</span> {
  <span class="hljs-attribute">width</span>: <span class="hljs-number">100%</span>;
  <span class="hljs-attribute">height</span>: auto;
}
<span class="hljs-selector-class">.ximg-error</span> {
  <span class="hljs-attribute">background-color</span>: yellow;
}
<span class="hljs-selector-class">.ximg-error</span><span class="hljs-selector-pseudo">:after</span> {
  <span class="hljs-attribute">content</span>: <span class="hljs-string">'加载失败'</span>;
  <span class="hljs-attribute">color</span>: red;
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">style</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// x-img-425.vue?3b528146